import { LiveLikeOption } from "@livelike/engagementsdk";
const html = (window as any).html;

class SBSTextPredictionFollowupOption extends LiveLikeOption {
  createRenderRoot(): this {
    return this;
  }

  votePercentage = () => {
    const items: any[] = (this as any).items || [];
    const totalVotes = items.reduce(
      (a: number, b: any) => a + (b?.vote_count || 0),
      0
    );
    const myVotes = (this as any).item?.vote_count || 0;
    return totalVotes > 0 ? Math.round((myVotes / totalVotes) * 100) : 0;
  };

  render() {
    const pct = this.votePercentage();
    this.style.setProperty("--vote-pct", `${pct}%`);
    return html`
      <div class="sbs-option-fill"></div>
      <div class="livelike-voting-text-container">
        <livelike-description></livelike-description>
        <span class="sbs-option-percent">${pct}%</span>
      </div>
    `;
  }
}
customElements.define(
  "sbs-text-prediction-followup-option",
  SBSTextPredictionFollowupOption as any
);
